import AirtableTable from "../AirtableTable";
import { Teacher } from "../models";
import { airtableFields, airtableTables } from "../schema";

export const teacherFieldIds = airtableFields.teachers;

export class TeacherTable extends AirtableTable<Teacher> {
  constructor(instance: any) {
    super(instance, airtableTables.teachers);

    this.fields = [
      teacherFieldIds.name,
      teacherFieldIds.email,
      teacherFieldIds.pronouns,
      teacherFieldIds.indigenousGroups,
      teacherFieldIds.gradesTaught,
      teacherFieldIds.subjectsTaught,
      teacherFieldIds.inSalesforce,
      teacherFieldIds.authBypass,
      teacherFieldIds.artist,
      teacherFieldIds.lastSeenAnnouncementAt
    ];
  }

  getTeacherByEmail = async (email: string) => {
    const normalizedEmail = email.trim().toUpperCase();
    const teachers = await this.listAll();
    return teachers.find((teacher: any) =>
      String(teacher[teacherFieldIds.email] || "").trim().toUpperCase() === normalizedEmail
    ) || null;
  }
}
